var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgSearchClose = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 20.627,
  height: 20.626
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 79",
  fill: "#4b555b"
}, /*#__PURE__*/React.createElement("path", {
  "data-name": "Line 44",
  d: "m19 20.626-19-19L1.626 0l19 19Z"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Line 44",
  d: "m1.626 20.626 19-19L19 0 0 19Z"
}))));
export default SvgSearchClose;